const routes = {
    name: 'Sales',
    icon: 'mdi-chart-line',
    path: '/reports/timhortons/sales/',
    children: [
      {
        path: '/reports/timhortons/sales/salesDetail',
        meta: { id: 'reports-SalesDetail' },
        name: 'Sales Detail',
        component: () => import('./SalesDetail.vue'),
        permissions: ['SalesDetail'],
      },
      {
        path: '/reports/timhortons/sales/salesLedger',
        meta: { id: 'reports-thSalesSalesLedger' },
        name: 'Sales Ledger',
        component: () => import('./SalesLedger.vue'),
        permissions: ['thSalesSalesLedger'],
      },
      {
        path: '/reports/timhortons/sales/qboDailySales',
        meta: { id: 'reports-thQboDailySales' },
        name: 'QBO Daily Sales',
        component: () => import('./QboDailySales.vue'),
        permissions: ['thSalesSalesLedger'],
      },
      {
        path: '/reports/timhortons/sales/closingHour',
        meta: { id: 'reports-thSalesClosingHour' },
        name: 'Closing Hour',
        component: () => import('./ClosingHour.vue'),
        permissions: ['thSalesClosingHour'],
      },
   
    ]
  };
  
  export default routes;
  